import mock from '../mock'

// ** Utils
import { paginateArray } from '../utils'

import avatar1 from '@src/assets/images/portrait/small/avatar-s-1.jpg'
import avatar2 from '@src/assets/images/portrait/small/avatar-s-2.jpg'
import avatar3 from '@src/assets/images/portrait/small/avatar-s-3.jpg'
import avatar4 from '@src/assets/images/portrait/small/avatar-s-4.jpg'
import avatar5 from '@src/assets/images/portrait/small/avatar-s-5.jpg'
import avatar6 from '@src/assets/images/portrait/small/avatar-s-6.jpg'
import avatar7 from '@src/assets/images/portrait/small/avatar-s-7.jpg'
import avatar8 from '@src/assets/images/portrait/small/avatar-s-8.jpg'
import avatar9 from '@src/assets/images/portrait/small/avatar-s-9.jpg'
import avatar10 from '@src/assets/images/portrait/small/avatar-s-10.jpg'

const data = [
  {
    responsive_id: '',
    id: 1,
    avatar: avatar10,
    full_name: "Lorem Ipsum",
    post: 'Dolor Sit',
    email: 'kocrevy0@thetimes.co.uk',
    city: 'Amet Consectetur',
    start_date: '09/23/2016',
    salary: 'P23896.35',
    age: '61',
    experience: '1 Year',
    status: 2
  },
  {
    responsive_id: '',
    id: 2,
    avatar: avatar1,
    full_name: 'Adipiscing Elit',
    post: 'Sed Do',
    email: 'bcoulman1@yolasite.com',
    city: 'Eiusmod Tempor',
    start_date: '05/20/2018',
    salary: 'P13633.69',
    age: '63',
    experience: '3 Years',
    status: 2
  },
  {
    responsive_id: '',
    id: 3,
    avatar: avatar9,
    full_name: 'Incididunt Ut',
    post: 'Labore Et',
    email: 'sganderton2@tuttocitta.it',
    city: 'Dolore Magna',
    start_date: '03/24/2018',
    salary: 'P13076.28',
    age: '66',
    experience: '6 Years',
    status: 5
  },
  {
    responsive_id: '',
    id: 4,
    avatar: avatar10,
    full_name: 'Aliqua Enim',
    post: 'Minim Veniam',
    email: 'dcrossman3@google.co.jp',
    city: 'Quis Nostrud',
    start_date: '12/03/2017',
    salary: 'P12336.17',
    age: '22',
    experience: '2 Years',
    status: 2
  },
  {
    responsive_id: '',
    id: 5,
    avatar: '',
    full_name: 'Exercitation Ullamco',
    post: 'Laboris Nisi',
    email: 'hnisius4@gnu.org',
    city: 'Ut Aliquip',
    start_date: '08/25/2017',
    salary: 'P10909.52',
    age: '33',
    experience: '3 Years',
    status: 2
  },
  {
    responsive_id: '',
    id: 6,
    avatar: '',
    full_name: 'Ex Ea',
    post: 'Commodo Consequat',
    email: 'ghoneywood5@narod.ru',
    city: 'Duis Aute',
    start_date: '06/01/2017',
    salary: 'P17803.80',
    age: '61',
    experience: '1 Year',
    status: 1
  },
  {
    responsive_id: '',
    id: 7,
    avatar: '',
    full_name: 'Irure Dolor',
    post: 'In Reprehenderit',
    email: 'ediehn6@163.com',
    city: 'In Voluptate',
    start_date: '10/15/2017',
    salary: 'P18991.67',
    age: '59',
    experience: '9 Years',
    status: 3
  },
  {
    responsive_id: '',
    id: 8,
    avatar: avatar9,
    full_name: 'Velit Esse',
    post: 'Cillum Dolore',
    email: 'raldren7@mtv.com',
    city: 'Eu Fugiat',
    start_date: '11/05/2016',
    salary: 'P19230.13',
    age: '55',
    experience: '5 Years',
    status: 3
  },
  {
    responsive_id: '',
    id: 9,
    avatar: avatar2,
    full_name: 'Nulla Pariatur',
    post: 'Excepteur Sint',
    email: 'amoakler8@shareasale.com',
    city: 'Occaecat Cupidatat',
    start_date: '12/29/2018',
    salary: 'P11677.32',
    age: '39',
    experience: '9 Years',
    status: 5
  },
  {
    responsive_id: '',
    id: 10,
    avatar: avatar9,
    full_name: 'Non Proident',
    post: 'Sunt In',
    email: 'mpenhalewick9@php.net',
    city: 'Culpa Qui',
    start_date: '04/19/2019',
    salary: 'P15939.52',
    age: '23',
    experience: '3 Years',
    status: 2
  },
  {
    responsive_id: '',
    id: 11,
    avatar: '',
    full_name: 'Officia Deserunt',
    post: 'Mollit Anim',
    email: 'dfalloona@ifeng.com',
    city: 'Id Est',
    start_date: '06/12/2018',
    salary: 'P19252.12',
    age: '30',
    experience: '0 Year',
    status: 4
  },
  {
    responsive_id: '',
    id: 12,
    avatar: '',
    full_name: 'Laborum Perspiciatis',
    post: 'Unde Omnis',
    email: 'cgornalb@fda.gov',
    city: 'Iste Natus',
    start_date: '12/09/2017',
    salary: 'P16745.47',
    age: '22',
    experience: '2 Years',
    status: 4
  },
  {
    responsive_id: '',
    id: 13,
    avatar: '',
    full_name: 'Error Sit',
    post: 'Voluptatem Accusantium',
    email: 'tbalfc@sina.com.cn',
    city: 'Doloremque',
    start_date: '01/21/2016',
    salary: 'P15488.53',
    age: '36',
    experience: '6 Years',
    status: 4
  },
  {
    responsive_id: '',
    id: 14,
    avatar: '',
    full_name: 'Laudantium Totam',
    post: 'Aperiam Eaque',
    email: 'oextilld@theatlantic.com',
    city: 'Ipsa Quae',
    start_date: '02/01/2016',
    salary: 'P18442.34',
    age: '43',
    experience: '3 Years',
    status: 2
  },
  {
    responsive_id: '',
    id: 15,
    avatar: '',
    full_name: 'Inventore Veritatis',
    post: 'Et Quasi',
    email: 'wbourtone@sakura.ne.jp',
    city: 'Architecto Beatae',
    start_date: '04/25/2018',
    salary: 'P13304.45',
    age: '19',
    experience: '9 Years',
    status: 5
  },
  {
    responsive_id: '',
    id: 16,
    avatar: avatar4,
    full_name: 'Vitae Dicta',
    post: 'Sunt Explicabo',
    email: 'rbrazenorf@symantec.com',
    city: 'Nemo Enim',
    start_date: '12/23/2017',
    salary: 'P11953.08',
    age: '66',
    experience: '6 Years',
    status: 5
  },
  {
    responsive_id: '',
    id: 17,
    avatar: '',
    full_name: 'Ipsam Voluptatem',
    post: 'Quia Voluptas',
    email: 'nbettensong@joomla.org',
    city: 'Sit Aspernatur',
    start_date: '07/11/2018',
    salary: 'P20484.44',
    age: '64',
    experience: '4 Years',
    status: 1
  },
  {
    responsive_id: '',
    id: 18,
    avatar: '',
    full_name: 'Aut Odit',
    post: 'Aut Fugit',
    email: 'thayneh@kickstarter.com',
    city: 'Sed Quia',
    start_date: '05/25/2019',
    salary: 'P16871.48',
    age: '59',
    experience: '9 Years',
    status: 1
  },
  {
    responsive_id: '',
    id: 19,
    avatar: avatar5,
    full_name: 'Consequuntur Magni',
    post: 'Dolores Eos',
    email: 'rhucki@ed.gov',
    city: 'Qui Ratione',
    start_date: '04/04/2019',
    salary: 'P19653.56',
    age: '41',
    experience: '1 Year',
    status: 4
  },
  {
    responsive_id: '',
    id: 20,
    avatar: avatar7,
    full_name: 'Voluptatem Sequi',
    post: 'Nesciunt Neque',
    email: 'llewteyj@sun.com',
    city: 'Porro Quisquam',
    start_date: '08/03/2017',
    salary: 'P18303.87',
    age: '35',
    experience: '5 Years',
    status: 1
  },
  {
    responsive_id: '',
    id: 21,
    avatar: 'avatar5',
    full_name: 'Tempor Incididunt',
    post: 'Ut Labore',
    email: 'user21@example.com',
    city: 'Et Dolore',
    start_date: '03/16/2019',
    salary: 'P15256.40',
    age: '30',
    experience: '0 Year',
    status: 2
  },
  {
    responsive_id: '',
    id: 22,
    avatar: 'avatar3',
    full_name: 'Magna Aliqua',
    post: 'Enim Ad',
    email: 'user22@example.com',
    city: 'Minim Veniam',
    start_date: '07/08/2017',
    salary: 'P11209.16',
    age: '40',
    experience: '0 Year',
    status: 3
  },
  {
    responsive_id: '',
    id: 23,
    avatar: 'avatar6',
    full_name: 'Quis Nostrud',
    post: 'Exercitation Ullamco',
    email: 'user23@example.com',
    city: 'Laboris Nisi',
    start_date: '12/23/2017',
    salary: 'P13778.34',
    age: '21',
    experience: '1 Year',
    status: 5
  },
  {
    responsive_id: '',
    id: 24,
    avatar: 'avatar7',
    full_name: 'Ut Aliquip',
    post: 'Ex Ea',
    email: 'user24@example.com',
    city: 'Commodo Consequat',
    start_date: '05/26/2016',
    salary: 'P23081.71',
    age: '23',
    experience: '3 Years',
    status: 1
  },
  {
    responsive_id: '',
    id: 25,
    avatar: 'avatar2',
    full_name: 'Duis Aute',
    post: 'Irure Dolor',
    email: 'user25@example.com',
    city: 'In Reprehenderit',
    start_date: '07/31/2019',
    salary: 'P13602.24',
    age: '47',
    experience: '7 Years',
    status: 3
  },
  {
    responsive_id: '',
    id: 26,
    avatar: 'avatar1',
    full_name: 'In Voluptate',
    post: 'Velit Esse',
    email: 'user26@example.com',
    city: 'Cillum Dolore',
    start_date: '04/10/2016',
    salary: 'P16969.63',
    age: '42',
    experience: '2 Years',
    status: 4
  },
  {
    responsive_id: '',
    id: 27,
    avatar: 'avatar4',
    full_name: 'Eu Fugiat',
    post: 'Nulla Pariatur',
    email: 'user27@example.com',
    city: 'Excepteur Sint',
    start_date: '09/29/2018',
    salary: 'P23796.62',
    age: '28',
    experience: '8 Years',
    status: 3
  },
  {
    responsive_id: '',
    id: 28,
    avatar: 'avatar5',
    full_name: 'Occaecat Cupidatat',
    post: 'Non Proident',
    email: 'user28@example.com',
    city: 'Sunt In',
    start_date: '07/09/2018',
    salary: 'P24027.81',
    age: '28',
    experience: '8 Years',
    status: 4
  },
  {
    responsive_id: '',
    id: 29,
    avatar: 'avatar8',
    full_name: 'Culpa Qui',
    post: 'Officia Deserunt',
    email: 'user29@example.com',
    city: 'Mollit Anim',
    start_date: '07/17/2016',
    salary: 'P13508.15',
    age: '48',
    experience: '8 Years',
    status: 3
  },
  {
    responsive_id: '',
    id: 30,
    avatar: 'avatar9',
    full_name: 'Id Est',
    post: 'Laborum Perspiciatis',
    email: 'user30@example.com',
    city: 'Unde Omnis',
    start_date: '08/28/2018',
    salary: 'P21632.30',
    age: '20',
    experience: '0 Year',
    status: 2
  },
  {
    responsive_id: '',
    id: 31,
    avatar: 'avatar10',
    full_name: 'Iste Natus',
    post: 'Error Sit',
    email: 'user31@example.com',
    city: 'Voluptatem Accusantium',
    start_date: '09/03/2016',
    salary: 'P24875.41',
    age: '37',
    experience: '7 Years',
    status: 5
  },
  {
    responsive_id: '',
    id: 32,
    avatar: 'avatar1',
    full_name: 'Doloremque Laudantium',
    post: 'Totam Rem',
    email: 'user32@example.com',
    city: 'Aperiam Eaque',
    start_date: '06/02/2016',
    salary: 'P23888.98',
    age: '53',
    experience: '3 Years',
    status: 2
  },
  {
    responsive_id: '',
    id: 33,
    avatar: 'avatar2',
    full_name: 'Ipsa Quae',
    post: 'Ab Illo',
    email: 'user33@example.com',
    city: 'Inventore Veritatis',
    start_date: '09/30/2016',
    salary: 'P14082.44',
    age: '27',
    experience: '7 Years',
    status: 5
  },
  {
    responsive_id: '',
    id: 34,
    avatar: 'avatar3',
    full_name: 'Quasi Architecto',
    post: 'Beatae Vitae',
    email: 'user34@example.com',
    city: 'Dicta Sunt',
    start_date: '04/07/2016',
    salary: 'P21386.52',
    age: '22',
    experience: '2 Years',
    status: 3
  },
  {
    responsive_id: '',
    id: 35,
    avatar: 'avatar4',
    full_name: 'Explicabo Nemo',
    post: 'Enim Ipsam',
    email: 'user35@example.com',
    city: 'Voluptatem Quia',
    start_date: '09/11/2019',
    salary: 'P13835.97',
    age: '46',
    experience: '6 Years',
    status: 4
  },
  {
    responsive_id: '',
    id: 36,
    avatar: 'avatar5',
    full_name: 'Voluptas Sit',
    post: 'Aspernatur Aut',
    email: 'user36@example.com',
    city: 'Odit Aut',
    start_date: '03/05/2019',
    salary: 'P22093.91',
    age: '47',
    experience: '7 Years',
    status: 4
  },
  {
    responsive_id: '',
    id: 37,
    avatar: 'avatar6',
    full_name: 'Fugit Sed',
    post: 'Quia Consequuntur',
    email: 'user37@example.com',
    city: 'Magni Dolores',
    start_date: '11/10/2018',
    salary: 'P24624.23',
    age: '51',
    experience: '1 Year',
    status: 3
  },
  {
    responsive_id: '',
    id: 38,
    avatar: 'avatar7',
    full_name: 'Eos Qui',
    post: 'Ratione Voluptatem',
    email: 'user38@example.com',
    city: 'Sequi Nesciunt',
    start_date: '11/04/2016',
    salary: 'P21782.82',
    age: '41',
    experience: '1 Year',
    status: 1
  },
  {
    responsive_id: '',
    id: 39,
    avatar: 'avatar8',
    full_name: 'Neque Porro',
    post: 'Quisquam Est',
    email: 'user39@example.com',
    city: 'Qui Dolorem',
    start_date: '07/18/2016',
    salary: 'P22794.60',
    age: '62',
    experience: '2 Years',
    status: 2
  },
  {
    responsive_id: '',
    id: 40,
    avatar: 'avatar9',
    full_name: 'Ipsam Voluptatem',
    post: 'Quia Voluptas',
    email: 'user40@example.com',
    city: 'Sit Aspernatur',
    start_date: '11/04/2018',
    salary: 'P10872.83',
    age: '37',
    experience: '7 Years',
    status: 4
  },
  {
    responsive_id: '',
    id: 41,
    avatar: 'avatar5',
    full_name: 'Ullamco Laboris',
    post: 'Nisi Aliquip',
    email: 'pbice14@ameblo.jp',
    city: 'Ex Commodo',
    start_date: '03/02/2016',
    salary: 'P17471.92',
    age: '65',
    experience: '5 Years',
    status: 5
  },
  {
    responsive_id: '',
    id: 42,
    avatar: 'avatar6',
    full_name: 'Consequat Duis',
    post: 'Aute Irure',
    email: 'lorsi15@wp.com',
    city: 'Dolor Reprehenderit',
    start_date: '12/10/2018',
    salary: 'P24719.51',
    age: '64',
    experience: '4 Years',
    status: 1
  },
  {
    responsive_id: '',
    id: 43,
    avatar: 'avatar7',
    full_name: 'Velit Esse',
    post: 'Cillum Dolore',
    email: 'dchaplyn16@nymag.com',
    city: 'Eu Fugiat',
    start_date: '01/23/2019',
    salary: 'P11958.33',
    age: '38',
    experience: '8 Years',
    status: 2
  },
  {
    responsive_id: '',
    id: 44,
    avatar: 'avatar8',
    full_name: 'Nulla Pariatur',
    post: 'Excepteur Sint',
    email: 'wbygraves17@howstuffworks.com',
    city: 'Occaecat Cupidatat',
    start_date: '09/07/2016',
    salary: 'P10552.43',
    age: '37',
    experience: '7 Years',
    status: 1
  },
  {
    responsive_id: '',
    id: 45,
    avatar: 'avatar9',
    full_name: 'Non Proident',
    post: 'Sunt Culpa',
    email: 'mbodechon18@1und1.de',
    city: 'Qui Officia',
    start_date: '07/23/2018',
    salary: 'P23024.28',
    age: '61',
    experience: '1 Year',
    status: 4
  },
  {
    responsive_id: '',
    id: 46,
    avatar: 'avatar10',
    full_name: 'Deserunt Mollit',
    post: 'Anim Laborum',
    email: 'mde19@purevolume.com',
    city: 'Fugiat Nulla',
    start_date: '02/10/2018',
    salary: 'P10409.90',
    age: '47',
    experience: '7 Years',
    status: 5
  },
  {
    responsive_id: '',
    id: 47,
    avatar: 'avatar1',
    full_name: 'Duis Aute',
    post: 'Irure Dolor',
    email: 'hchatelot1a@usatoday.com',
    city: 'Reprehenderit Voluptate',
    start_date: '11/23/2016',
    salary: 'P11446.30',
    age: '64',
    experience: '4 Years',
    status: 4
  },
  {
    responsive_id: '',
    id: 48,
    avatar: 'avatar2',
    full_name: 'Velit Esse',
    post: 'Cillum Dolore',
    email: 'gmccrum1b@icio.us',
    city: 'Eu Fugiat',
    start_date: '04/19/2018',
    salary: 'P14002.31',
    age: '63',
    experience: '3 Years',
    status: 1
  },
  {
    responsive_id: '',
    id: 49,
    avatar: 'avatar3',
    full_name: 'Nulla Pariatur',
    post: 'Excepteur Sint',
    email: 'kstilldale1c@chronoengine.com',
    city: 'Occaecat Cupidatat',
    start_date: '03/18/2017',
    salary: 'P10704.29',
    age: '56',
    experience: '6 Years',
    status: 1
  },
  {
    responsive_id: '',
    id: 50,
    avatar: 'avatar4',
    full_name: 'Non Proident',
    post: 'Sunt Culpa',
    email: 'mumbert1d@digg.com',
    city: 'Qui Officia',
    start_date: '05/13/2019',
    salary: 'P21813.54',
    age: '43',
    experience: '3 Years',
    status: 1
  },
  {
    responsive_id: '',
    id: 51,
    avatar: 'avatar5',
    full_name: 'Ut Aliquip',
    post: 'Ex Ea',
    email: 'user51@example.com',
    city: 'Commodo',
    start_date: '04/23/2019',
    salary: 'P18053.11',
    age: '46',
    experience: '6 Years',
    status: 3
  },
  {
    responsive_id: '',
    id: 52,
    avatar: 'avatar6',
    full_name: 'Consequat Duis',
    post: 'Aute Irure',
    email: 'user52@example.com',
    city: 'Reprehenderit',
    start_date: '04/19/2016',
    salary: 'P17617.08',
    age: '47',
    experience: '7 Years',
    status: 3
  },
  {
    responsive_id: '',
    id: 53,
    avatar: 'avatar7',
    full_name: 'In Voluptate',
    post: 'Velit Esse',
    email: 'user53@example.com',
    city: 'Cillum',
    start_date: '10/06/2018',
    salary: 'P18866.55',
    age: '21',
    experience: '1 Year',
    status: 5
  },
  {
    responsive_id: '',
    id: 54,
    avatar: 'avatar8',
    full_name: 'Dolore Eu',
    post: 'Fugiat Nulla',
    email: 'user54@example.com',
    city: 'Pariatur',
    start_date: '06/15/2017',
    salary: 'P13722.18',
    age: '30',
    experience: '0 Year',
    status: 3
  },
  {
    responsive_id: '',
    id: 55,
    avatar: 'avatar9',
    full_name: 'Excepteur Sint',
    post: 'Occaecat Cupidatat',
    email: 'user55@example.com',
    city: 'Non Proident',
    start_date: '09/26/2018',
    salary: 'P15228.80',
    age: '51',
    experience: '1 Year',
    status: 1
  },
  {
    responsive_id: '',
    id: 56,
    avatar: 'avatar10',
    full_name: 'Sunt In',
    post: 'Culpa Qui',
    email: 'user56@example.com',
    city: 'Officia Deserunt',
    start_date: '01/03/2016',
    salary: 'P13951.96',
    age: '29',
    experience: '9 Years',
    status: 1
  },
  {
    responsive_id: '',
    id: 57,
    avatar: 'avatar1',
    full_name: 'Mollit Anim',
    post: 'Id Est',
    email: 'user57@example.com',
    city: 'Laborum',
    start_date: '02/04/2018',
    salary: 'P15100.00',
    age: '27',
    experience: '7 Years',
    status: 4
  },
  {
    responsive_id: '',
    id: 58,
    avatar: 'avatar2',
    full_name: 'Laborum Perspiciatis',
    post: 'Unde Omnis',
    email: 'user58@example.com',
    city: 'Iste Natus',
    start_date: '04/22/2016',
    salary: 'P20023.52',
    age: '28',
    experience: '9 Years',
    status: 5
  },
  {
    responsive_id: '',
    id: 59,
    avatar: 'avatar3',
    full_name: 'Error Sit',
    post: 'Voluptatem Accusantium',
    email: 'user59@example.com',
    city: 'Doloremque',
    start_date: '04/08/2019',
    salary: 'P12630.26',
    age: '28',
    experience: '1 Year',
    status: 2
  },
  {
    responsive_id: '',
    id: 60,
    avatar: 'avatar4',
    full_name: 'Laudantium Totam',
    post: 'Rem Aperiam',
    email: 'user60@example.com',
    city: 'Eaque Ipsa',
    start_date: '08/13/2019',
    salary: 'P13870.62',
    age: '48',
    experience: '5 Years',
    status: 4
  },
  {
    responsive_id: '',
    id: 61,
    avatar: 'avatar5',
    full_name: 'Quae Abillo',
    post: 'Inventore Veritatis',
    email: 'user61@example.com',
    city: 'Et Quasi',
    start_date: '11/06/2017',
    salary: 'P18220.51',
    age: '20',
    experience: '0 Year',
    status: 3
  },
  {
    responsive_id: '',
    id: 62,
    avatar: 'avatar6',
    full_name: 'Architecto Beatae',
    post: 'Vitae Dicta',
    email: 'user62@example.com',
    city: 'Sunt Explicabo',
    start_date: '08/05/2017',
    salary: 'P13999.88',
    age: '37',
    experience: '0 Year',
    status: 5
  },
  {
    responsive_id: '',
    id: 63,
    avatar: 'avatar7',
    full_name: 'Nemo Enim',
    post: 'Ipsam Voluptatem',
    email: 'user63@example.com',
    city: 'Quia Voluptas',
    start_date: '09/12/2019',
    salary: 'P11049.79',
    age: '53',
    experience: '1 Year',
    status: 5
  },
  {
    responsive_id: '',
    id: 64,
    avatar: 'avatar8',
    full_name: 'Aspernatur Aut',
    post: 'Odit Aut',
    email: 'user64@example.com',
    city: 'Fugit Sed',
    start_date: '08/25/2017',
    salary: 'P10745.32',
    age: '27',
    experience: '3 Years',
    status: 5
  },
  {
    responsive_id: '',
    id: 65,
    avatar: 'avatar9',
    full_name: 'Quia Consequuntur',
    post: 'Magni Dolores',
    email: 'user65@example.com',
    city: 'Eos Qui',
    start_date: '05/24/2018',
    salary: 'P24769.08',
    age: '22',
    experience: '7 Years',
    status: 1
  },
  {
    responsive_id: '',
    id: 66,
    avatar: 'avatar10',
    full_name: 'Ratione Voluptatem',
    post: 'Sequi Nesciunt',
    email: 'user66@example.com',
    city: 'Neque Porro',
    start_date: '02/27/2019',
    salary: 'P16053.15',
    age: '46',
    experience: '2 Years',
    status: 1
  },
  {
    responsive_id: '',
    id: 67,
    avatar: 'avatar1',
    full_name: 'Quisquam Est',
    post: 'Qui Dolorem',
    email: 'user67@example.com',
    city: 'Ipsum Quia',
    start_date: '09/23/2017',
    salary: 'P23347.17',
    age: '47',
    experience: '8 Years',
    status: 5
  },
  {
    responsive_id: '',
    id: 68,
    avatar: 'avatar2',
    full_name: 'Dolor Sit',
    post: 'Amet Consectetur',
    email: 'user68@example.com',
    city: 'Adipisci Velit',
    start_date: '11/01/2016',
    salary: 'P15658.40',
    age: '51',
    experience: '8 Years',
    status: 1
  },
  {
    responsive_id: '',
    id: 69,
    avatar: 'avatar3',
    full_name: 'Sed Quia',
    post: 'Non Numquam',
    email: 'user69@example.com',
    city: 'Eius Modi',
    start_date: '07/15/2018',
    salary: 'P15396.66',
    age: '41',
    experience: '8 Years',
    status: 2
  },
  {
    responsive_id: '',
    id: 70,
    avatar: 'avatar4',
    full_name: 'Tempora Incidunt',
    post: 'Ut Labore',
    email: 'user70@example.com',
    city: 'Et Dolore',
    start_date: '05/22/2016',
    salary: 'P15823.40',
    age: '62',
    experience: '0 Year',
    status: 5
  },
  {
    responsive_id: '',
    id: 71,
    avatar: 'Praesentium',
    full_name: 'Maxime Voluptate',
    post: 'Excepturi Sint',
    email: 'email71@example.com',
    city: 'Occaecati',
    start_date: '01/01/2018',
    salary: 'P50000.00',
    age: '30',
    experience: '10 Years',
    status: 1
  },
  {
    responsive_id: '',
    id: 72,
    avatar: 'Cupiditate',
    full_name: 'Non Provident',
    post: 'Similique Sunt',
    email: 'email72@example.com',
    city: 'Consequatur',
    start_date: '02/02/2018',
    salary: 'P52000.00',
    age: '31',
    experience: '9 Years',
    status: 2
  },
  {
    responsive_id: '',
    id: 73,
    avatar: 'Facere',
    full_name: 'Possimus Omnis',
    post: 'Voluptas Assumenda',
    email: 'email73@example.com',
    city: 'Est Omnis',
    start_date: '03/03/2018',
    salary: 'P53000.00',
    age: '32',
    experience: '8 Years',
    status: 3
  },
  {
    responsive_id: '',
    id: 74,
    avatar: 'Laborum',
    full_name: 'Et Dolorum',
    post: 'Fuga Et',
    email: 'email74@example.com',
    city: 'Harum Quidem',
    start_date: '04/04/2018',
    salary: 'P54000.00',
    age: '33',
    experience: '7 Years',
    status: 4
  },
  {
    responsive_id: '',
    id: 75,
    avatar: 'Rerum',
    full_name: 'Facilis Est',
    post: 'Et Expedita',
    email: 'email75@example.com',
    city: 'Distinctio Nam',
    start_date: '05/05/2018',
    salary: 'P55000.00',
    age: '34',
    experience: '6 Years',
    status: 5
  },
  {
    responsive_id: '',
    id: 76,
    avatar: 'Libero',
    full_name: 'Temporibus Autem',
    post: 'Quibusdam Officiis',
    email: 'email76@example.com',
    city: 'Debitis Aut',
    start_date: '06/06/2018',
    salary: 'P56000.00',
    age: '35',
    experience: '5 Years',
    status: 1
  },
  {
    responsive_id: '',
    id: 77,
    avatar: 'Tempora',
    full_name: 'Autem Vel',
    post: 'Illum Qui',
    email: 'email77@example.com',
    city: 'Dolorem Eum',
    start_date: '07/07/2018',
    salary: 'P57000.00',
    age: '36',
    experience: '4 Years',
    status: 2
  },
  {
    responsive_id: '',
    id: 78,
    avatar: 'Incidunt',
    full_name: 'Ullam Corporis',
    post: 'Suscipit Laboriosam',
    email: 'email78@example.com',
    city: 'Nisi Ut',
    start_date: '08/08/2018',
    salary: 'P58000.00',
    age: '37',
    experience: '3 Years',
    status: 3
  },
  {
    responsive_id: '',
    id: 79,
    avatar: 'Aliquid',
    full_name: 'Ex Ea',
    post: 'Commodi Consequatur',
    email: 'email79@example.com',
    city: 'Quis Autem',
    start_date: '09/09/2018',
    salary: 'P59000.00',
    age: '38',
    experience: '2 Years',
    status: 4
  },
  {
    responsive_id: '',
    id: 80,
    avatar: 'Vel Illum',
    full_name: 'Qui Dolorem',
    post: 'Eum Fugiat',
    email: 'email80@example.com',
    city: 'Quo Voluptas',
    start_date: '10/10/2018',
    salary: 'P60000.00',
    age: '39',
    experience: '1 Year',
    status: 5
  },
  {
    responsive_id: '',
    id: 81,
    avatar: 'Nihil',
    full_name: 'Impedit Quo',
    post: 'Minus Id',
    email: 'email81@example.com',
    city: 'Quod Maxime',
    start_date: '11/11/2018',
    salary: 'P61000.00',
    age: '40',
    experience: '10 Years',
    status: 1
  },
  {
    responsive_id: '',
    id: 82,
    avatar: 'Placeat',
    full_name: 'Facere Possimus',
    post: 'Omnis Voluptas',
    email: 'email82@example.com',
    city: 'Assumenda Est',
    start_date: '12/12/2018',
    salary: 'P62000.00',
    age: '41',
    experience: '9 Years',
    status: 2
  },
  {
    responsive_id: '',
    id: 83,
    avatar: 'Omnis',
    full_name: 'Dolor Reprehenderit',
    post: 'Qui Blanditiis',
    email: 'email83@example.com',
    city: 'Praesentium Voluptatum',
    start_date: '01/01/2019',
    salary: 'P63000.00',
    age: '42',
    experience: '8 Years',
    status: 3
  },
  {
    responsive_id: '',
    id: 84,
    avatar: 'Deleniti',
    full_name: 'Atque Corrupti',
    post: 'Quos Dolores',
    email: 'email84@example.com',
    city: 'Et Quas',
    start_date: '02/02/2019',
    salary: 'P64000.00',
    age: '43',
    experience: '7 Years',
    status: 4
  },
  {
    responsive_id: '',
    id: 85,
    avatar: 'Molestias',
    full_name: 'Excepturi Sint',
    post: 'Occaecati Cupiditate',
    email: 'email85@example.com',
    city: 'Non Provident',
    start_date: '03/03/2019',
    salary: 'P65000.00',
    age: '44',
    experience: '6 Years',
    status: 5
  },
  {
    responsive_id: '',
    id: 86,
    avatar: 'Similique',
    full_name: 'Sunt In',
    post: 'Culpa Qui',
    email: 'email86@example.com',
    city: 'Officia Deserunt',
    start_date: '04/04/2019',
    salary: 'P66000.00',
    age: '45',
    experience: '5 Years',
    status: 1
  },
  {
    responsive_id: '',
    id: 87,
    avatar: 'Mollitia',
    full_name: 'Animi Id',
    post: 'Est Laborum',
    email: 'email87@example.com',
    city: 'Et Dolorum',
    start_date: '05/05/2019',
    salary: 'P67000.00',
    age: '46',
    experience: '4 Years',
    status: 2
  },
  {
    responsive_id: '',
    id: 88,
    avatar: 'Fugiat',
    full_name: 'Harum Quidem',
    post: 'Rerum Facilis',
    email: 'email88@example.com',
    city: 'Est Et',
    start_date: '06/06/2019',
    salary: 'P68000.00',
    age: '47',
    experience: '3 Years',
    status: 3
  },
  {
    responsive_id: '',
    id: 89,
    avatar: 'Expedita',
    full_name: 'Distinctio Nam',
    post: 'Libero Temporibus',
    email: 'email89@example.com',
    city: 'Autem Quibusdam',
    start_date: '07/07/2019',
    salary: 'P69000.00',
    age: '48',
    experience: '2 Years',
    status: 4
  },
  {
    responsive_id: '',
    id: 90,
    avatar: 'Aut Officiis',
    full_name: 'Debitis Aut',
    post: 'Rerum Necessitatibus',
    email: 'email90@example.com',
    city: 'Saepe Eveniet',
    start_date: '08/08/2019',
    salary: 'P18523.75',
    age: '28',
    experience: '3 Years',
    status: 1
  },
  {
    responsive_id: '',
    id: 91,
    avatar: '',
    full_name: 'Laboris Nisi',
    post: 'Ut Aliquip',
    email: 'jbartosik2i@state.gov',
    city: 'Ex Ea',
    start_date: '02/06/2017',
    salary: 'P17607.66',
    age: '48',
    experience: '6 Years',
    status: 3
  },
  {
    responsive_id: '',
    id: 92,
    avatar: avatar3,
    full_name: 'Commodo Consequat',
    post: 'Duis Aute',
    email: 'yemberton2j@blog.com',
    city: 'Irure Dolor',
    start_date: '02/13/2017',
    salary: 'P17550.18',
    age: '20',
    experience: '1 Year',
    status: 4
  },
  {
    responsive_id: '',
    id: 93,
    avatar: avatar8,
    full_name: 'Reprehenderit In',
    post: 'Voluptate Velit',
    email: 'dfaichnie2k@weather.com',
    city: 'Esse Cillum',
    start_date: '07/29/2019',
    salary: 'P18469.35',
    age: '37',
    experience: '3 Years',
    status: 4
  },
  {
    responsive_id: '',
    id: 94,
    avatar: '',
    full_name: 'Dolore Eu',
    post: 'Fugiat Nulla',
    email: 'rhasted2l@hexun.com',
    city: 'Pariatur',
    start_date: '07/04/2019',
    salary: 'P24866.66',
    age: '53',
    experience: '7 Years',
    status: 4
  },
  {
    responsive_id: '',
    id: 95,
    avatar: avatar2,
    full_name: 'Excepteur Sint',
    post: 'Occaecat Cupidatat',
    email: 'eebsworth2m@sbwire.com',
    city: 'Non Proident',
    start_date: '09/27/2018',
    salary: 'P19586.23',
    age: '27',
    experience: '2 Years',
    status: 1
  },
  {
    responsive_id: '',
    id: 96,
    avatar: '',
    full_name: 'Sunt In',
    post: 'Culpa Qui',
    email: 'abeslier2n@zimbio.com',
    city: 'Officia Deserunt',
    start_date: '04/16/2017',
    salary: 'P19366.53',
    age: '22',
    experience: '8 Years',
    status: 4
  },
  {
    responsive_id: '',
    id: 97,
    avatar: '',
    full_name: 'Mollit Anim',
    post: 'Id Est',
    email: 'rpeckett2o@timesonline.co.uk',
    city: 'Laborum',
    start_date: '05/20/2018',
    salary: 'P16619.40',
    age: '46',
    experience: '8 Years',
    status: 4
  },
  {
    responsive_id: '',
    id: 98,
    avatar: avatar7,
    full_name: 'Lorem Ipsum',
    post: 'Dolor Sit',
    email: 'ogudgin2p@gizmodo.com',
    city: 'Amet Consectetur',
    start_date: '04/09/2019',
    salary: 'P15211.60',
    age: '47',
    experience: '8 Years',
    status: 2
  },
  {
    responsive_id: '',
    id: 99,
    avatar: avatar10,
    full_name: 'Adipiscing Elit',
    post: 'Sed Do',
    email: 'ecarnock2q@washington.edu',
    city: 'Eiusmod Tempor',
    start_date: '01/26/2017',
    salary: 'P23704.82',
    age: '51',
    experience: '0 Year',
    status: 4
  },
  {
    responsive_id: '',
    id: 100,
    avatar: '',
    full_name: 'Incididunt Ut',
    post: 'Labore Et',
    email: 'ggiacoppo2r@apache.org',
    city: 'Dolore Magna',
    start_date: '04/15/2017',
    salary: 'P24973.48',
    age: '41',
    experience: '7 Years',
    status: 2
  }
]

mock.onGet('/api/latindata/initial-data').reply(() => {
  return [200, data]
})

mock.onGet('/api/latindata/data').reply(config => {
  // eslint-disable-next-line object-curly-newline
  const { q = '', perPage = 10, page = 1 } = config
  /* eslint-enable */

  const queryLowered = q.toLowerCase()
  const filteredData = data.filter(
    item =>
      /* eslint-disable operator-linebreak, implicit-arrow-linebreak */
      item.full_name.toLowerCase().includes(queryLowered) ||
      item.post.toLowerCase().includes(queryLowered) ||
      item.email.toLowerCase().includes(queryLowered) ||
      item.age.toLowerCase().includes(queryLowered) ||
      item.salary.toLowerCase().includes(queryLowered) ||
      item.start_date.toLowerCase().includes(queryLowered)
  )
  /* eslint-enable  */

  return [
    200,
    {
      allData: data,
      invoices: paginateArray(filteredData, perPage, page),
      total: filteredData.length
    }
  ]
})
